import * as React from 'react';
import { memo } from 'react';

const SvgMapPin = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 10.625a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.25 8.125c0 5.625-6.25 10-6.25 10s-6.25-4.375-6.25-10a6.25 6.25 0 0 1 12.5 0v0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgMapPin);

export { Memo as default };
